const CalculateWorkingTime = (target) => {
  // * CalculateWorkingTime.cshtml
  // * WorkingHoursController.cs

  const method = {
    init: () => {
      if (target) {
        const form = target;

        form.addEventListener("submit", (e) => {
          e.preventDefault();
          method.submit(form);
        });
      }
    },

    submit: async (form) => {
      const button = form.querySelector("button[type=submit]");
      const callout = form.querySelector(".callout");
      const data = new FormData(form);
      const action = form.getAttribute("action");
      const formMethod = form.getAttribute("method");

      if (callout) callout.remove();

      button.disabled = true;
      button.classList.add("button--loading");

      fetch(action, {
        method: formMethod,
        body: data,
      })
        .then(res => res.json())
        .then((response) => {
          if (response.success) {
            method.renderMessage(form, response);
            // form.reset();
          } else {
            method.renderError(form, response.message, "error");
          }
          setTimeout(() => {
            button.classList.remove("button--loading");
            button.disabled = false;
          }, 150);
        })
        .catch((ex) => {
          method.renderError(form, `Server error: ${ex} `, "error");
        });
    },

    renderMessage: (form, response) => {
      const day = form.querySelector(".js-calculate--time-day");
      const week = form.querySelector(".js-calculate--time-week");
      const month = form.querySelector(".js-calculate--time-month");
      const result = form.querySelector(".js-calculate--time-results");
      const saRate = form.querySelector(".js-calculate--time-saRate");
      const sfRate = form.querySelector(".js-calculate--time-sfRate");
      const nochange = form.querySelector(".js-calculate--time-nochange");

      if (response.saRate === "") {
        day.innerHTML = response.day;
        week.innerHTML = response.week;
        month.innerHTML = response.month;
        nochange.style.display = "none";
        result.style.display = "block";
      } else {
        saRate.innerHTML = response.saRate;
        sfRate.innerHTML = response.sfRate;
        result.style.display = "none";
        nochange.style.display = "block";
      }
    },

    renderError: (el, message, type) => {
      el.insertAdjacentHTML(
        "beforeend",
        `<div class="callout callout--${type}">${message}</div>`
      );
    },
  };

  method.init();
};

export default CalculateWorkingTime;
